import { useInstance } from '@meraki-internal/react-dependency-injection';
import { DeviceInfo } from '../support/DeviceInfo';
import { useDevSettings } from './useDevSettings';

// Returns true if native app, or web with simulateNative dev setting;
// otherwise returns false
export const useIsNative = () => {

    const deviceInfo = useInstance(DeviceInfo);
    const devSettings = useDevSettings();

    return devSettings.simulateNative || deviceInfo.platform !== 'web';
};
